import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_mobile-sidebar_account_dropdown-click';
/**
 * https:&#x2F;&#x2F;www.notion.so&#x2F;faire&#x2F;mWeb-bottom-nav-e289d4aa07d640bfa07019c14a532303
 */
export function trackRetailerMobileSidebarAccountDropdownClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
